export default {
  setCodeAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setUserSource", payload)
      resolve()
    })
  }
}
